import { gql } from '@apollo/client'
import { SERVICE_BUNDLES_QUERY, CURRENCY_DATES_QUERY } from '../graphql'
import { FIELD_ID } from '../components/CustomCode/Woodcosts/woodcosts_constants'
import { makeInteger } from '../utils'

const SERVICE_BUNDLES = gql(SERVICE_BUNDLES_QUERY)
const CURRENCY_DATES = gql(CURRENCY_DATES_QUERY)

const woodcosts = {
  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    console.log('woodcosts.validation_hook', fieldInput, objectId, formInputs)
    let validationMessage = ''
    switch (makeInteger(fieldInput.field.id)) {
      case FIELD_ID.invoice.invoiceDate:
        if (fieldInput.currentValue) {
          const currency = formInputs[FIELD_ID.invoice.currency].currentValue
          if (currency.id) {
            const results = await window.apolloClient.query({ query: CURRENCY_DATES, variables: { currencyId: currency.id, invoiceDate: fieldInput.currentValue } })
            if (!results.data.currencyDates) {
              validationMessage = `There is no exchange rate available for currency "${currency.name}" within a date range that includes ${fieldInput.field.name} "${fieldInput.currentValue}".  Please add the Exchange Rate/Date Range and try again.`
            }
          }
        }
        break
      default:
        validationMessage = ''
    }
    console.log('validationMessage: ', validationMessage)
    return validationMessage
  },

  choice_hook: async function choice_hook(field, object, parentObjectId, allInputs) {
    console.log('woodcosts.choice_hook', field, object, parentObjectId, allInputs)
    let choices = []
    switch (makeInteger(field.id)) {
      case FIELD_ID.invoice.serviceBundle:
      case FIELD_ID.invoiceDetail.serviceBundle:
        let businessGroupId
        if (makeInteger(field.id) === FIELD_ID.invoice.serviceBundle) {
          businessGroupId = allInputs[FIELD_ID.invoice.businessGroup].currentValue.id
        } else if (makeInteger(field.id) === FIELD_ID.invoiceDetail.serviceBundle) {
          businessGroupId = allInputs[FIELD_ID.invoiceDetail.businessGroup].currentValue.id
        }
        console.log(`businessGroupId: ${businessGroupId}`)
        if (businessGroupId) {
          const results = await window.apolloClient.query({ query: SERVICE_BUNDLES, variables: { businessGroupId: businessGroupId } })
          console.log('woodcosts.choice_hook: ', results)
          choices = results.data.serviceBundles
        }
        break
      default:
        console.log(`woodcosts.choice_hook field "${field.name}" not handled.`)
    }
    return choices
  }
}

export default woodcosts
